import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { HamViewsResponse } from './hamViewsTypes.tsx';

const WORKSPACE_LIST_URL = '/rest/servicedesk/cmdb/latest/workspace';

type WorkspaceQueryResponse = {
	size: number;
	hasNextPage: boolean;
	results: { id: string }[];
};

async function fetchInsightWorkspaceId(): Promise<string | null> {
	try {
		const response = await performGetRequest<WorkspaceQueryResponse>(WORKSPACE_LIST_URL);
		const id = response.results?.[0]?.id;
		return id ?? null;
	} catch {
		return null;
	}
}

export const HAM_VIEWS_RESOURCE_KEY = 'ITAM_HAM_DASHBOARD_VIEWS';

export const hamViewsResource: RouteResource<HamViewsResponse> = createResource<HamViewsResponse>({
	type: HAM_VIEWS_RESOURCE_KEY,
	getKey: ({ match }) => {
		const practice = match.params.practice ?? '';
		return `${HAM_VIEWS_RESOURCE_KEY}_${practice}`;
	},
	getData: async (_routerContext, _customContext) => {
		const workspaceId = await fetchInsightWorkspaceId();
		if (workspaceId == null) {
			throw new Error('Workspace ID not available');
		}
		return performGetRequest<HamViewsResponse>(
			`/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/views`,
		);
	},
	maxAge: 1000 * 60 * 5, // 5 minutes
});
